export default {
  common: {
    save: "सेव करें",
    cancel: "रद्द करें",
    back: "वापस",
    submit: "सबमिट करें",
    loading: "लोड हो रहा है…",
    yes: "हाँ",
    no: "नहीं",
    confirm: "पुष्टि करें",
    close: "बंद करें",
    search: "खोजें",
    all: "सभी",
    done: "हो गया",
    logout: "लॉग आउट",
    language: "भाषा",
    selectLanguage: "अपनी भाषा चुनें",
    saving: "सेव हो रहा है…",
    saved: "सेव हो गया",
    viewAll: "सभी देखें",
    filters: "फ़िल्टर",
  },
  nav: {
    home: "होम",
    installs: "इंस्टॉलेशन",
    requests: "अनुरोध",
    orders: "ऑर्डर",
    profile: "प्रोफ़ाइल",
    leads: "लीड्स",
    service: "सेवा",
    payouts: "भुगतान",
    toolkit: "टूलकिट",
  },
  profile: {
    yourAccount: "आपका खाता",
    title: "प्रोफ़ाइल.",
    city: "शहर",
    state: "राज्य",
    pinCode: "पिन कोड",
    pinCodeHelp: "आपका क्षेत्र वह अनुमत क्षेत्र है जिसमें यह पिन कोड आता है।",
    upiId: "यूपीआई आईडी (भुगतान के लिए)",
    saveProfile: "प्रोफ़ाइल सेव करें",
    preferredLanguage: "पसंदीदा भाषा",
    logoutConfirm: "क्या आप वाकई लॉग आउट करना चाहते हैं?",
    linkedAddresses: "जुड़े हुए पते",
    noAddresses: "अभी तक कोई पता सेव नहीं किया गया।",
    referFriend: "दोस्त को रेफ़र करें",
    referFriendSub: "अपना कोड साझा करें — वे सोलर लगवाएं तो आपको इनाम मिलेगा।",
    myReferrals: "मेरे रेफ़रल",
    shareFriend: "दोस्त के साथ साझा करें",
    secureNote: "आपका डेटा सुरक्षित फ़ोन ओटीपी से सत्यापित है — कोई पासवर्ड याद रखने या खोने की ज़रूरत नहीं।",
    toolkit: "टूलकिट",
    incentiveSchemes: "इंसेंटिव योजनाएं",
  },
  tickets: {
    myRequests: "मेरे अनुरोध",
    raiseComplaint: "शिकायत दर्ज करें",
    cancelRequest: "अनुरोध रद्द करें",
    cancelConfirmTitle: "क्या इस अनुरोध को रद्द करें?",
    cancelConfirmBody: "हम इस सेवा अनुरोध पर काम रोक देंगे। आप बाद में फिर से नया अनुरोध कर सकते हैं।",
    cancelledToast: "अनुरोध रद्द किया गया",
    keepRequest: "नहीं, रहने दें",
    noRequests: "अभी तक कोई सेवा अनुरोध नहीं है।",
    statusOpen: "खुला",
    statusInProgress: "प्रगति पर",
    statusOnHold: "रोका गया",
    statusActionNeeded: "कार्रवाई आवश्यक",
    statusCompleted: "पूरा हुआ",
    statusClosed: "बंद",
    statusCancelled: "रद्द",
    statusDropped: "ड्रॉप किया गया",
    filterAll: "सभी",
    filterActive: "सक्रिय",
    filterResolved: "हल किया गया",
    nonServiceable: "गैर-सेवा योग्य क्षेत्र",
    raisedOn: "दर्ज किया गया",
    ticketNumber: "टिकट",
    wipInstall: "इंस्टॉलेशन जारी",
    raisedByYou: "आपने दर्ज किया",
    raisedByTeam: "हमारी टीम ने दर्ज किया",
    timeline: "समयरेखा",
    pending: "लंबित",
    resolutionSummary: "समाधान सारांश",
    youRatedPrefix: "आपने इसे रेट किया",
    howWasResolution: "समाधान कैसा रहा?",
    submitFeedback: "फ़ीडबैक सबमिट करें",
  },
  home: {
    greeting: "नमस्ते",
    newInstallation: "नई इंस्टॉलेशन",
    raiseComplaint: "शिकायत दर्ज करें",
    welcomeBack: "वापसी पर स्वागत है",
    customerSubtitle: "पूर्वोदय के साथ आपकी सोलर यात्रा, सब एक जगह।",
  },
  sc: {
    requestsTitle: "सेवा अनुरोध",
    requestsForCustomers: "आपके ग्राहकों के लिए",
    kpiOpen: "खुला",
    kpiResolved: "हल किया गया",
    kpiInProblem: "समस्या में",
    raiseRequest: "सेवा अनुरोध दर्ज करें",
    slaBreached: "SLA उल्लंघन",
    viewPhotos: "फ़ोटो देखें",
    hidePhotos: "फ़ोटो छिपाएं",
    noRequestsWindow: "इस अवधि में कोई सेवा अनुरोध नहीं।",
  },
};
